var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V13.3333H0V0ZM10 3.33333C10.8841 3.33333 11.7319 3.68452 12.357 4.30964C12.9821 4.93476 13.3333 5.78261 13.3333 6.66667C13.3333 7.55072 12.9821 8.39857 12.357 9.02369C11.7319 9.64881 10.8841 10 10 10C9.11595 10 8.2681 9.64881 7.64298 9.02369C7.01786 8.39857 6.66667 7.55072 6.66667 6.66667C6.66667 5.78261 7.01786 4.93476 7.64298 4.30964C8.2681 3.68452 9.11595 3.33333 10 3.33333ZM4.44444 2.22222C4.44444 2.81159 4.21032 3.37682 3.79357 3.79357C3.37682 4.21032 2.81159 4.44444 2.22222 4.44444V8.88889C2.81159 8.88889 3.37682 9.12302 3.79357 9.53976C4.21032 9.95651 4.44444 10.5217 4.44444 11.1111H15.5556C15.5556 10.5217 15.7897 9.95651 16.2064 9.53976C16.6232 9.12302 17.1884 8.88889 17.7778 8.88889V4.44444C17.1884 4.44444 16.6232 4.21032 16.2064 3.79357C15.7897 3.37682 15.5556 2.81159 15.5556 2.22222H4.44444Z",
    fill: "#22943E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.8cc3fda2fb1eee3d0bc808275f00472f.svg";
export { ForwardRef as ReactComponent };